<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
import emptyLayout from '@/layouts/emptyLayout.vue'
import mainLayout from '@/layouts/mainLayout.vue'
import { mapActions } from 'vuex'
export default {
  computed: {
    layout() {
      return (this.$route.meta.layout || 'empty') + '-layout'
    }
  },
  components: {
    emptyLayout,
    mainLayout
  },
  methods: {
    ...mapActions('auth', ['verifyToken'])
  },
  mounted() {
    try {
      this.verifyToken()
    } catch (error) {
      this.$router.push('/auth')
    }
  }
}
</script>

<style scoped>
  @import url("https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200");
  #app {
    height: 100vh;
    overflow: hidden;
    background: white;
  }
</style>
